import { useMemo } from 'react';
import { Marker } from 'react-leaflet';
import L from 'leaflet';
import type { Spot } from '@ridehub/shared';
import type { SpotCategory } from '@ridehub/shared';
import { CATEGORY_MAP } from '@ridehub/shared';

interface SpotMarkerProps {
  spot: Spot;
  onSelect: (spot: Spot) => void;
}

function createCategoryIcon(category: SpotCategory): L.DivIcon {
  const def = CATEGORY_MAP.get(category);
  const icon = def?.icon ?? '📍';
  const color = def?.color ?? '#9E9E9E';

  return L.divIcon({
    html: `
      <div style="
        background: ${color};
        border: 2px solid white;
        border-radius: 50% 50% 50% 0;
        transform: rotate(-45deg);
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 4px rgba(0,0,0,0.3);
      ">
        <span style="transform: rotate(45deg); font-size: 16px;">${icon}</span>
      </div>
    `,
    className: '',
    iconSize: [32, 32],
    iconAnchor: [16, 32],
  });
}

export function SpotMarker({ spot, onSelect }: SpotMarkerProps) {
  const icon = useMemo(() => createCategoryIcon(spot.category as SpotCategory), [spot.category]);

  return (
    <Marker
      position={[spot.latitude, spot.longitude]}
      icon={icon}
      eventHandlers={{ click: () => onSelect(spot) }}
    />
  );
}
